import { ADMIN_ROLES } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

import { AuthController } from '../auth-controller';

export class PartnerOverviewController extends AuthController {
  public pageId = 'partnerOverview';
  public path = '/admn/partnerOverview/:partnerAccountId';
  public routeName = 'partnerOverview';
  public bundles = [];
  public pageTitle = 'controllers.partnerOverview';
  public isAdminView = true;
  public accessRoles = [
    ADMIN_ROLES.INTERNAL_COLLECTIONS_MANAGER,
    ADMIN_ROLES.INTERNAL_ADMIN,
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
  ];

  public readOnlyAccessRoles = [
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
  ];

  public component = codeSplit(
    () => import(/* webpackChunkName: "partnerOverview" */ '../../views/admin/partner-overview'),
  );
  public exact = true;
}
